import axios from 'axios';

import { ICmsAdvertisementCategory } from '@/shared/model/cms-advertisement-category.model';

const baseApiUrl = 'api/cms-advertisement-categories';

export default class CmsAdvertisementCategoryService {
  public find(id: number): Promise<ICmsAdvertisementCategory> {
    return new Promise<ICmsAdvertisementCategory>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICmsAdvertisementCategory): Promise<ICmsAdvertisementCategory> {
    return new Promise<ICmsAdvertisementCategory>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICmsAdvertisementCategory): Promise<ICmsAdvertisementCategory> {
    return new Promise<ICmsAdvertisementCategory>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
